module.exports = __webpack_public_path__ + "img/chisel-app.065169ac.jpg";